<template>
	<div>
		<div class="timeline_row" v-for="(incident, index) in incidents" :key="index">
			<div class="timeline_left">
				<div class="timeline_name" v-if="incident.team === 'home'">
					<div v-if="incident.players.main">
						{{ incident.players.main.name }}
						<div class="" v-if="incident.incedent_name === 'Power Play goal'">(Большинство)</div>
					</div>
					<div v-else>
						<div class="timeline_name __color-1">{{ incident.players.in.name }}</div>
						<div class="timeline_name __color-2">{{ incident.players.out.name }}</div>
					</div>
				</div>
				<div class="timeline_time" v-if="incident.team === 'away'">{{ incident.time }}'</div>
			</div>
			<div class="timeline_center">
				<div class="timeline_cart __card __yellow" v-if="incident.incedent_type === 'card'">
					{{ parseInt(incident.incedent_name) }}
				</div>
				<div class="timeline_ball __hockey" v-if="incident.incedent_type === 'goal'"></div>
				<div class="timeline_arrow" v-if="incident.incedent_type === 'subst'">
					<div class="timeline_arrow-up"></div>
					<div class="timeline_arrow-down"></div>
				</div>
			</div>
			<div class="timeline_right">
				<div class="timeline_name" v-if="incident.team === 'away'">
					<div v-if="incident.players.main">
						{{ incident.players.main.name }}
						<div class="" v-if="incident.incedent_name === 'Power Play goal'">(Большинство)</div>
					</div>
					<div v-else>
						<div class="timeline_name __color-1">{{ incident.players.in.name }}</div>
						<div class="timeline_name __color-2">{{ incident.players.out.name }}</div>
					</div>
				</div>
				<div class="timeline_time" v-if="incident.team === 'home'">{{ incident.time }}'</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['incidents', 'time'],
	}
</script>

<style scoped>

</style>